import {BulletPointType, Nullable} from "../../definitions/types";
import {BulletPointModel} from "../domain/bulletPointModel";

export class BulletPointsModel {
    private readonly _bulletPoints: BulletPointModel[];

    constructor(public readonly bulletPoints: Nullable<BulletPointType>[]) {
        this._bulletPoints = bulletPoints
            .filter((bulletPoint): bulletPoint is BulletPointType => bulletPoint !== null)
            .map((bulletPoint) => new BulletPointModel(bulletPoint));
    }

    /**
     * @method count
     * @description Returns the number of bullet points
     * @returns {number}
     */
    public get count(): number {
        return this._bulletPoints.length;
    }

    /**
     * @method getBulletPoints
     * @param skip - The number of bullet points to skip (default: 0)
     * @param take - The number of bullet points to take (default: Number.MAX_SAFE_INTEGER)
     * @description Returns bullet points with pagination information
     * @returns {{pagination: {pageCount: number; hasNextPage: boolean; pageSize: number; hasPreviousPage: boolean; page: number; itemCount: number}; bulletPoints: BulletPointModel[]}}
     */
    public getBulletPoints(skip: number = 0, take: number = Number.MAX_SAFE_INTEGER): {
        pagination: {
            pageCount: number;
            hasNextPage: boolean;
            pageSize: number;
            hasPreviousPage: boolean;
            page: number;
            itemCount: number
        };
        bulletPoints: BulletPointModel[]
    } {
        // Account for negative skip
        if (skip < 0) skip = 0;

        // Account for negative take
        if (take < 0) take = 0;

        // Account for skip greater than bullet points length
        if (skip > this._bulletPoints.length) skip = this._bulletPoints.length;

        // Account for take plus skip greater than bullet points length
        if (take + skip > this._bulletPoints.length) take = this._bulletPoints.length - skip;

        // Return bullet points from skip to skip + take
        return {
            bulletPoints: this._bulletPoints.slice(skip, skip + take),
            pagination: {
                page: Math.floor(skip / take) + 1,
                pageSize: take,
                pageCount: Math.ceil(this._bulletPoints.length / take),
                itemCount: this._bulletPoints.length,
                hasPreviousPage: skip > 0,
                hasNextPage: skip + take < this._bulletPoints.length
            }
        }
    };
}